import { Alert, Button, Modal, Table } from "antd";
import { formatDate } from "utils/helpers";
import { BatchClaimTestFileListModalProps } from "./Proptypes";

const BatchClaimTestFileListModal = ({testFiles, visible, isModalVisibleHandler, setVisible, ...rest}: BatchClaimTestFileListModalProps) => {

  const columns = [
    {
      title: 'Date Submitted',
      key: 'RmiCreatedDate',
      dataIndex: 'RmiCreatedDate',
      sorter: (a: any, b: any) => a.RmiCreatedDate.localeCompare(b.RmiCreatedDate),
      render: (value: string) => formatDate(value, 'MM/DD/YYYY')
    },
    {
      title: 'Filename',
      key: 'RmiOriginalFilename',
      dataIndex: 'RmiOriginalFilename',
      sorter: (a: any, b: any) => a.RmiFilename.localeCompare(b.RmiFilename),
    },
  ];
  
  return (
    <Modal
      {...rest}
      visible={visible}
      onCancel={isModalVisibleHandler}
      maskClosable={false}
    >
      <Alert 
        type="error"
        showIcon
        message="You have outstanding test files being processed. Click Continue to submit another one."
        action={
          <Button size="small" type="primary" onClick={() => setVisible(false)} danger>
            Continue
          </Button>
        }
      />
      <br />
      <Table
        dataSource={testFiles}
        columns={columns}
      />
    </Modal>
  );
};

export default BatchClaimTestFileListModal;